// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:27
import { ScannedAssembly_abstract } from './../../abstract/SagaBase/Factory/ScannedAssembly_abstract';
export class ScannedAssembly extends ScannedAssembly_abstract {}
